import React from "react";
import { Section } from "./layout/Sections";
import { theme } from "theme/theme";

const Colors = () => {
  return (
    <Section title="Paleta de Colores del Tema">
      <div className="container mx-auto py-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {Object.entries(theme.colors).map(([colorName, colorClass]) => (
            <div
              key={colorName}
              className="flex flex-col items-center p-4 rounded-lg shadow-md bg-white border border-gray-200"
            >
              <div
                className={`w-full h-24 rounded-md mb-4 ${"bg-" + colorClass}`}
              ></div>
              <p className="text-sm font-semibold text-gray-600">{colorName}</p>
              <p className="text-xs text-gray-500">`{colorClass}`</p>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Colors;
